import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const RobotCleaner = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M8 .833a7.167 7.167 0 1 0 0 14.335A7.167 7.167 0 0 0 8 .833zM.167 8a7.833 7.833 0 1 1 15.666 0A7.833 7.833 0 0 1 .167 8z" />
      <path d="M8 4.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334zM6.667 5a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0z" />
      <path d="M5 .792c.184 0 .333.149.333.333V5a2.668 2.668 0 0 0 5.334 0V1.125a.333.333 0 1 1 .666 0V5a3.333 3.333 0 1 1-6.666 0V1.125c0-.184.149-.333.333-.333zM4.229 11.299c.13-.13.341-.13.471 0a4.667 4.667 0 0 0 6.6 0 .333.333 0 0 1 .471.471 5.334 5.334 0 0 1-7.542 0 .333.333 0 0 1 0-.471z" />
    </svg>
  );
};

RobotCleaner.category = 'product-category';

RobotCleaner.displayName = 'RobotCleaner';
